import { AccordionSummary, Grid, Typography } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import EditIcon from '@material-ui/icons/Edit';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import VisibilityIcon from '@material-ui/icons/Visibility';
import MaterialTable from 'material-table';
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../../../services/api';
import { findPermission } from '../../../../services/auth';
import useStyles from '../style';
import Loading from '../../../../components/Loading';
import { FilterStatusHeader } from './FilterStatusHeader';
import { canShowEdit } from '../../../../utils/functions';

export function ContactGroup({ providerId, isEditing, grupoFornecedorId }) {
  const classes = useStyles();

  const [contactGroup, setContactGroup] = useState([]);
  const [status, setStatus] = useState('ativo');
  const [isLoading, setLoading] = useState(false);

  const memoizedTable = useMemo(
    () => (
      <MaterialTable
        localization={{
          body: {
            emptyDataSourceMessage: <span></span>,
          },
        }}
        className={classes.table}
        options={{
          showTitle: false,
          search: false,
          toolbar: false,
          headerStyle: {
            backgroundColor: '#F5F5F5',
            textTransform: 'none',
            fontSize: '15px',
          },
          filtering: true,
          paging: false,
        }}
        onRowClick={(event, rowData) => {
          if(!!findPermission(2730, 'Alterar') && canShowEdit()) {
            window.location.href = window.location.origin + `/app/fornecedor/${providerId}/grupo-contato/${rowData.grupoFornecedorContatoId}/editar`
          }
        }}
        title="Multiple Actions Preview"
        columns={[
          {
            title: 'Nome',
            field: 'nome',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 10px',
            },
          },
          {
            title: 'Email',
            field: 'email',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Telefone',
            field: 'telefone1',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Status',
            field: 'status',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Ações',
            field: 'actions',
            headerStyle: {
              textAlign: 'center',
            },
            cellStyle: {
              fontSize: '13px',
              textAlign: 'center',
              padding: '8px 16px',
            },
            filtering: false,
            sorting: false,
            disableClick: true,
            render: (rowData) => (
              <>
                {!!findPermission(2730, 'Consultar') && (
                  <Link
                    className={classes.buttonVisualize}
                    to={`/app/fornecedor/${providerId}/grupo-contato/${rowData.grupoFornecedorContatoId}`}
                  >
                    <VisibilityIcon style={{ fontSize: 30, color: '#4AAF05' }} />
                  </Link>
                )}
                {!!findPermission(2730, 'Alterar') && canShowEdit() && (
                  <Link
                    className={classes.buttonEdit}
                    to={`/app/fornecedor/${providerId}/grupo-contato/${rowData.grupoFornecedorContatoId}/editar`}
                  >
                    <EditIcon style={{ fontSize: 30, color: '#FB8832' }} />
                  </Link>
                )}
              </>
            ),
          },
        ]}
        data={contactGroup}
      />
    ),
    [contactGroup],
  );

  const fetchContactInfo = async () => {
    setLoading(true);
    const res = await api.get(
      `GruposFornecedoresContatos/ConsultarGrupoFornecedorId?grupoFornecedorId=${grupoFornecedorId}&${
        status ? `status=${status}` : ''
      }`,
    );
    if (
      res.data.resposta?.[0]?.key === 'Notificacao' ||
      res.data.resposta?.[0]?.key === '' ||
      res.data.resposta?.[0]?.message === 'Valor não encontrado'
    ) {
      setContactGroup([]);
    } else {
      setContactGroup(
        res.data.resposta.map((contact) => ({
          ...contact,
          telefone1:
            (contact?.ddd1 ? `(${contact?.ddd1}) ` : '') +
            `${contact?.telefone1}` +
            (contact?.ramal1 ? ` Ramal: ${contact?.ramal1}` : ''),
          telefone2:
            (contact?.ddd2 ? `(${contact?.ddd2}) ` : '') +
            `${contact?.telefone2}` +
            (contact?.ramal2 ? ` Ramal: ${contact?.ramal2}` : ''),
        })),
      );
    }
    setLoading(false);
  };
  useEffect(() => {
    if (providerId) {
      fetchContactInfo();
    }
  }, []);

  useEffect(() => {
    if (providerId) {
      fetchContactInfo();
    }
  }, [providerId]);

  return (
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
        <Typography className={classes.heading}>Contatos</Typography>
      </AccordionSummary>

      <AccordionDetails className={classes.details}>
        <Grid container>
          <Grid item xs={12} className={classes.registerBtn}>
            <FilterStatusHeader
              fetchFunc={fetchContactInfo}
              status={status}
              setStatus={setStatus}
            />
            {isEditing && !!findPermission(2730, 'Cadastrar') && (
              <Link
                className={classes.button}
                to={`/app/fornecedor/${providerId}/cadastrar-grupo-contato`}
              >
                Novo Item
              </Link>
            )}
          </Grid>

          {isLoading ? (
            <Loading />
          ) : (
            <Grid item xs={12}>
              {memoizedTable}
            </Grid>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
